import GSAP from 'gsap'
import { horizontalLoop } from 'utils/loop'

import Animation from 'classes/Animation'

export default class Slider extends Animation {
  constructor({ element, elements }) {
    super({
      element: '.page_gallery',
      elements: {
        wrapper: '.page_gallery_wrapper',
        img: '.page_gallery_item'
      }
    })

    this.body = document.body

    this.createModal()

    if (window.innerWidth > 821) {
      this.createInteractions()
    }

    this.loop = horizontalLoop(this.elements.img, { draggable: true, repeat: -1, paused: true })

    this.tl = GSAP.timeline()
  }

  createModal = () => {
    this.createWrapper = document.createElement('div')
    this.body.appendChild(this.createWrapper)

    this.addClass = this.createWrapper.classList.add('page_gallery_fullscreen')
    this.bigwrapper = document.querySelector('.page_gallery_fullscreen')

    this.createimg = document.createElement('img')
    this.bigimg = this.bigwrapper.appendChild(this.createimg)
    this.bigimg.classList.add('page_gallery_fullscreen_item')
    this.modalimg = document.querySelector('.page_gallery_fullscreen_item')
  }

  playSlider = () => {
    this.loop.play()
  }

  stopSlider = () => {
    this.loop.pause()
  }

  imgInteractions = (element) => {
    this.current = element.srcElement

    document.documentElement.style.overflow = 'hidden'

    this.modalimg.src = this.current.getAttribute('data-src')

    this.bigwrapper.style.display = 'flex'

    this.tl.clear()

    GSAP.set(this.modalimg, {
      yPercent: 0
    })

    this.tl.fromTo(this.modalimg, {
      scale: 0,
      autoAlpha: 0
    }, {
      scale: 1,
      autoAlpha: 1,
      duration: 0.5,
      ease: 'power4.inOut',
      onComplete: this.initDrag
    }).restart()

    this.rect = 0
    this.height = 0
    this.remove = 0
  }

  initDrag = () => {
    window.addEventListener('mousemove', this.dragPos)
    this.bigwrapper.addEventListener('click', this.closeImg)

    this.rect = this.modalimg.getBoundingClientRect()
    this.height = this.rect.height
    this.remove = window.innerHeight / this.height

    this.stopSlider()
  }

  dragPos = (e) => {
    this.mousepos = (e.clientY / window.innerHeight) - this.remove

    this.interp = this.mousepos * 100

    if (this.interp < 0) {
      this.interp = 0
    }

    GSAP.to(this.modalimg, {
      yPercent: -this.interp
    })
  }

  closeImg = () => {
    document.documentElement.style.overflow = 'auto'

    GSAP.fromTo(this.bigimg, {
      scale: 1,
      autoAlpha: 1,
      duration: 0.5,
      ease: 'power4.out'
    }, {
      scale: 0,
      autoAlpha: 0,
      duration: 0.5,
      ease: 'power4.out'
    })

    this.playSlider()

    this.bigwrapper.style.display = 'none'
    this.bigwrapper.removeEventListener('click', this.closeImg)
    window.removeEventListener('mousemove', this.dragPos)
  }

  createInteractions = () => {
    if (window.innerWidth > 821) {
      this.elements.wrapper.addEventListener('mouseover', this.stopSlider)
      this.elements.wrapper.addEventListener('mouseout', this.playSlider)
      if (this.elements.img.length > 1) {
        this.elements.img.forEach((element) => {
          element.addEventListener('click', this.imgInteractions)
        })
      } else {
        this.elements.img.addEventListener('click', this.imgInteractions)
      }
    } else {

      this.elements.wrapper.removeEventListener('mouseover', this.stopSlider)
      this.elements.wrapper.removeEventListener('mouseout', this.playSlider)
      this.elements.img.forEach((element) => {
        element.removeEventListener('click', this.imgInteractions)
      })
    }
  }

  animateIn() {
    this.playSlider()
  }

  animateOut() {
  }
}
